export default "__VITE_ASSET__BHX58Uiz__"